module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/png@2x/chart_line_percent_stacked@2x-ed398b.png";